import { CHART_COLORS } from "../styles/theme";

/* Palette des motifs d'absence (dans l'ordre renvoyé par l'API) */
const REASON_PALETTE = [
    CHART_COLORS.grey,
    CHART_COLORS.violet,
    CHART_COLORS.blue,
    CHART_COLORS.violetMid,
    CHART_COLORS.violetSoft,
    CHART_COLORS.blueSoft,
];

const MONTHS_SHORT_FR = [
    "Jan",
    "Fév",
    "Mar",
    "Avr",
    "Mai",
    "Juin",
    "Juil",
    "Août",
    "Sep",
    "Oct",
    "Nov",
    "Déc",
];

/** Libellé d'axe : "Mar" ou "Mar 25" si la série couvre plusieurs années */
const monthLabel = (row, multiYear) =>
    `${MONTHS_SHORT_FR[(row.month ?? 1) - 1]}${
        multiYear ? ` ${String(row.year).slice(-2)}` : ""
    }`;

/**
 * Transforme la réponse de GET /hr/pilotage/absenteisme en modèle
 * consommé par AbsencesSection.
 */
export const mapAbsenteisme = (api) => {
    const joursAbsence = api.absence_days ?? 0;
    const motifs = (api.by_reason ?? []).map((r, i) => ({
        name: r.category_label,
        value: r.days ?? 0,
        pct:
            joursAbsence > 0
                ? Math.round(((r.days ?? 0) / joursAbsence) * 100)
                : 0,
        color: REASON_PALETTE[i % REASON_PALETTE.length],
    }));

    const monthly = api.monthly_absenteeism ?? [];
    const multiYear = new Set(monthly.map((r) => r.year)).size > 1;

    return {
        joursTravailles: api.worked_days ?? 0,
        joursTravaillesPrevious: api.worked_days_previous ?? null,
        joursAbsence,
        joursAbsencePrevious: api.absence_days_previous ?? null,
        taux: api.absenteeism_rate ?? 0,
        tauxPrevious: api.absenteeism_rate_previous ?? null,
        dureeMoyenne: api.average_duration ?? 0,
        dureeMoyennePrevious: api.average_duration_previous ?? null,
        frequence: api.frequency ?? 0,
        frequencePrevious: api.frequency_previous ?? null,
        motifs,
        evolutionLabels: monthly.map((r) => monthLabel(r, multiYear)),
        evolutionTaux: monthly.map((r) => r.absenteeism_rate ?? 0),
    };
};
